import { render, staticRenderFns } from "./KitDinamicoForm.vue?vue&type=template&id=da319e02"
import script from "./KitDinamicoForm.vue?vue&type=script&lang=ts"
export * from "./KitDinamicoForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports